import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';

export const ContactUs = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
    .send("service_gandiMJ","template_FirstContact",
      {
        to_name: "Papa Noel",
        from_name: "Petit Enfant",
        from_email: "FromEmain@m-j.fr",
        reply_to: "ReplyTo@m-j.fr",
        message: "Message depuis internet pour mon Noel",
      },
      {
        publicKey: 'l_sQyM5FAHQl1hDOq',
      }
    )
    /*
      .sendForm(
        'service_gandiMJ',          // Remplacez par votre service ID
        'template_FirstContact',    // Remplacez par votre template ID
        form.current,            // Référence au formulaire HTML
         {
          publicKey: 'l_sQyM5FAHQl1hDOq'           // Remplacez par votre clé publique EmailJS
         }
      ) */
      .then(
        () => {
          console.log('SUCCESS!');
          alert('SUCCESS!');
        },
        (error) => {
          console.log('FAILED...', error.text);
          console.log('FAILED...', error);
          alert('FAILED...', error);
        },
      );
  };

  return (
    <form ref={form} onSubmit={sendEmail}>
      <label>Name</label>
      <input type="text" name="user_name" />
      <label>Email</label>
      <input type="email" name="user_email" />
      <label>Message</label>
      <textarea name="message" />
      <input type="submit" value="Send" />
    </form>
  );
};

export default ContactUs;